<div class="flex flex-col gap-2">

  <div class="flex flex-col md:flex-row gap-2 items-center" *ngIf="needApplication">
    <span class="font-semibold text-lg">Add Administrator Information</span>
    <button mat-button type="button" color="primary" (click)="createApplication()">Add</button>
  </div>

  <form [formGroup]="applicationForm" *ngIf="!needApplication">
    <div class="flex flex-col gap-2">
      <div class="flex flex-col" [ngClass]="!isChange? 'md:flex-row gap-2' : ''">
        <mat-card [ngClass]="!isChange? 'md:w-1/2' : ''">
          <mat-card-content>
            <div class="flex flex-row gap-2 items-center">
              <span class="font-semibold text-xl">Administrator Applicant Information</span>
              <button class="ml-auto" type="button" *ngIf="application.possibleDuplicate"
                mat-button color="warn" (click)="showAdminNotice()">Possible Duplicate Admin</button>
              <button class="ml-auto" type="button" *ngIf="(approved || renewal) && !isChange"
                mat-button color="primary" (click)="requestChange()">Change Administrator</button>
            </div>

            <div class="flex flex-col gap-2 pt-4">
              <div class="flex flex-col md:flex-row gap-2">

                <div class="flex flex-col gap-2 md:w-2/5">
                  <span class="font-semibold">First Name</span>
                  <mat-form-field>
                    <mat-label>First</mat-label>
                    <input matInput formControlName="firstName" (blur)="checkIfAdminExists()">
                    <mat-error *ngIf="applicationForm.get('firstName').invalid">
                      First name is required
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="flex flex-col gap-2 md:w-2/5">
                  <span class="font-semibold">Last Name</span>
                  <mat-form-field>
                    <mat-label>Last</mat-label>
                    <input matInput formControlName="lastName" (blur)="checkIfAdminExists()">
                    <mat-error *ngIf="applicationForm.get('lastName').invalid">
                      Last name is required
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="flex flex-col gap-2 md:w-1/5">
                  <span class="font-semibold"><strong>Middle Initial</strong></span>
                  <mat-form-field>
                    <mat-label>M.I.</mat-label>
                    <input matInput formControlName="middleInitial">
                  </mat-form-field>
                </div>
              </div>

              <div class="flex flex-col md:flex-row gap-2">
                <div class="flex flex-col gap-2 md:w-1/3">
                  <span class="font-semibold"><strong>Phone</strong></span>
                  <mat-form-field>
                    <mat-label>Phone</mat-label>
                    <input matInput formControlName="phone" mask="000-000-0000">
                    <mat-error *ngIf="applicationForm.get('phone').hasError('required')">
                      Number is required
                    </mat-error>
                    <mat-error *ngIf="applicationForm.get('phone').hasError('pattern')">
                      Format as 000-000-0000
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="flex flex-col gap-2 md:w-1/3">
                  <span class="font-semibold">Email</span>
                  <mat-form-field>
                    <mat-label>Email</mat-label>
                    <input matInput formControlName="email">
                    <mat-error *ngIf="applicationForm.get('email').hasError('required')">
                    An email is required
                    </mat-error>
                    <mat-error *ngIf="applicationForm.get('email').hasError('email')">
                    This does not look like a valid email
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="flex flex-col gap-2 md:w-1/2">
                  <label id="admin-client-contact">
                    Does the administrator have direct contact with any client as defined in OAR 333-536-0093?
                    (If yes, attach 'Background Check Request'.)
                  </label>
                  <mat-radio-group aria-labelledby="admin-client-contact" formControlName="contactWithClient" (change)="updateRequiredDocuments($event)">
                    <mat-radio-button [value]="true">
                      Yes
                    </mat-radio-button>
                    <mat-radio-button [value]="false">
                      No
                    </mat-radio-button>
                  </mat-radio-group>

                  <button type="button"  *ngIf="applicationForm.get('contactWithClient').value"
                        class="portal-text-action"
                        [@slideRight]
                        (click)="downloadReferenceDocument(sharedService.emptyBackgroundCheck)">
                    Download Background Check Request Form
                  </button>
                </div>

              </div>

              <span *ngIf="applicationForm.get('contactWithClient').value === false" class="portal-error" [@slideRight]>
                Note: there are regulations requiring administrators to be on site a minimum number of days per week.
                If you still believe that you will not have any contact with clients, even accidentally, you must provide
                a written explanation and plan for how you will ensure that you have no contact with clients.
              </span>

              <address [entityId]="application.id"
                       [entityType]="sharedService.administratorApplication"
                       [canEdit]="true"
                       [limitEntries]="true"
                       (reportOutOfState)="updateOutOfState($event)"></address>

              <div class="flex flex-col gap-4" *ngIf="isOutOfState" [@slideRight]>
                <span class="font-semibold">Administrators who reside outside of Oregon must have fingerprints taken.</span>
                <button type="button"  class="portal-text-action" (click)="downloadReferenceDocument(sharedService.fingerprints)">
                  Download Fingerprint Instructions
                </button>
              </div>

            </div>
          </mat-card-content>
        </mat-card>

        <mat-card [ngClass]="!isChange? 'md:w-1/2' : ''">
          <mat-card-header>
            <mat-card-title class="pb-4">
              <span class="font-semibold text-xl">Education</span>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="flex flex-col">
              <div class="flex flex-col md:flex-row gap-2">
                <div class="flex flex-col gap-2 md:w-2/5">
                  <span class="font-semibold">High School / Equivalent</span>
                  <mat-form-field>
                    <mat-label>Name</mat-label>
                    <input matInput formControlName="highSchool">
                  </mat-form-field>
                </div>

                <div class="flex flex-col gap-2 md:w-3/5" *ngIf="applicationForm.get('highSchool').value.length > 0" [@slideRight]>
                  <span class="font-semibold">Address</span>
                  <mat-form-field>
                    <mat-label>Address</mat-label>
                    <input matInput formControlName="highSchoolAddress">
                  </mat-form-field>
                </div>
              </div>

              <div class="flex flex-col md:flex-row gap-2 md:items-center" *ngIf="applicationForm.get('highSchool').value.length > 0" [@slideRight]>
                <div class="flex flex-col md:w-1/4 gap-2 pt-5">
                  <span class="font-semibold">From</span>
                  <mat-form-field>
                    <input placeholder="mm/dd/yyyy" formControlName="highSchoolFrom" matInput [matDatepicker]="hsFrom" [max]="sharedService.today"/>
                    <mat-datepicker-toggle matSuffix [for]="hsFrom"></mat-datepicker-toggle>
                    <mat-datepicker #hsFrom>
                      <mat-datepicker-actions>
                        <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                        <button mat-button matDatepickerCancel>Cancel</button>
                      </mat-datepicker-actions>
                    </mat-datepicker>
                  </mat-form-field>
                </div>

                <div class="flex flex-col md:w-1/4 gap-2 pt-5">
                  <span class="font-semibold">To</span>
                  <mat-form-field>
                    <input placeholder="mm/dd/yyyy" formControlName="highSchoolTo" matInput [matDatepicker]="hsTo"
                    [min]="applicationForm.get('highSchoolFrom').value" [max]="sharedService.today" (blur)="validateHighSchoolTo()"/>
                    <mat-datepicker-toggle matSuffix [for]="hsTo"></mat-datepicker-toggle>
                    <mat-datepicker #hsTo>
                      <mat-datepicker-actions>
                        <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                        <button mat-button matDatepickerCancel>Cancel</button>
                      </mat-datepicker-actions>
                    </mat-datepicker>
                    <mat-error *ngIf="applicationForm.get('highSchoolTo').invalid">
                      To date cannot be before From date
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="flex flex-col gap-2 md:w-1/2">
                  <mat-checkbox formControlName="graduatedHighSchool" labelPosition="before">
                    <span class="font-semibold">Graduated</span>
                  </mat-checkbox>
                  <mat-form-field>
                    <mat-label>Degree</mat-label>
                    <input matInput formControlName="highSchoolDegree">
                  </mat-form-field>
                </div>
              </div>

              <div class="flex flex-col md:flex-row gap-2">
                <div class="flex flex-col gap-2 md:w-2/5">
                  <span class="font-semibold">College</span>
                  <mat-form-field>
                    <mat-label>Name</mat-label>
                    <input matInput formControlName="college">
                  </mat-form-field>
                </div>

                <div class="flex flex-col gap-2 md:w-3/5" *ngIf="applicationForm.get('college').value.length > 0" [@slideRight]>
                  <span class="font-semibold">Address</span>
                  <mat-form-field>
                    <mat-label>Address</mat-label>
                    <input matInput formControlName="collegeAddress">
                  </mat-form-field>
                </div>
              </div>

              <div class="flex flex-col md:flex-row gap-2 md:items-center" *ngIf="applicationForm.get('college').value.length > 0" [@slideRight]>
                <div class="flex flex-col md:w-1/4 gap-2 pt-5">
                  <span class="font-semibold">From</span>
                  <mat-form-field>
                    <input placeholder="mm/dd/yyyy" formControlName="collegeFrom" matInput [matDatepicker]="colFrom" [max]="sharedService.today"/>
                    <mat-datepicker-toggle matSuffix [for]="colFrom"></mat-datepicker-toggle>
                    <mat-datepicker #colFrom>
                      <mat-datepicker-actions>
                        <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                        <button mat-button matDatepickerCancel>Cancel</button>
                      </mat-datepicker-actions>
                    </mat-datepicker>
                  </mat-form-field>
                </div>

                <div class="flex flex-col md:w-1/4 gap-2 pt-5">
                  <span class="font-semibold">To</span>
                  <mat-form-field>
                    <input placeholder="mm/dd/yyyy" formControlName="collegeTo" matInput [matDatepicker]="colTo"
                    [min]="applicationForm.get('collegeFrom').value" [max]="sharedService.today" (blur)="validateCollegeTo()"/>
                    <mat-datepicker-toggle matSuffix [for]="colTo"></mat-datepicker-toggle>
                    <mat-datepicker #colTo>
                      <mat-datepicker-actions>
                        <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                        <button mat-button matDatepickerCancel>Cancel</button>
                      </mat-datepicker-actions>
                    </mat-datepicker>
                    <mat-error *ngIf="applicationForm.get('collegeTo').invalid">
                      To date cannot be before From date
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="flex flex-col gap-2 md:w-1/2">
                  <mat-checkbox formControlName="graduatedCollege" labelPosition="before">
                    <span class="font-semibold">Graduated</span>
                  </mat-checkbox>
                  <mat-form-field>
                    <mat-label>Degree</mat-label>
                    <input matInput formControlName="collegeDegree">
                  </mat-form-field>
                </div>
              </div>

              <div class="flex flex-col md:flex-row gap-2">
                <div class="flex flex-col gap-2 md:w-2/5">
                  <span class="font-semibold">Other</span>
                  <mat-form-field>
                    <mat-label>Name</mat-label>
                    <input matInput formControlName="other">
                  </mat-form-field>
                </div>

                <div class="flex flex-col gap-2 md:w-3/5" *ngIf="applicationForm.get('other').value.length > 0" [@slideRight]>
                  <span class="font-semibold">Address</span>
                  <mat-form-field>
                    <mat-label>Address</mat-label>
                    <input matInput formControlName="otherAddress">
                  </mat-form-field>
                </div>
              </div>

              <div class="flex flex-col md:flex-row gap-2 md:items-center" *ngIf="applicationForm.get('other').value.length > 0" [@slideRight]>
                <div class="flex flex-col md:w-1/4 gap-2 pt-5">
                  <span class="font-semibold">From</span>
                  <mat-form-field>
                    <input placeholder="mm/dd/yyyy" formControlName="otherFrom" matInput [matDatepicker]="otherFrom" [max]="sharedService.today"/>
                    <mat-datepicker-toggle matSuffix [for]="otherFrom"></mat-datepicker-toggle>
                    <mat-datepicker #otherFrom>
                      <mat-datepicker-actions>
                        <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                        <button mat-button matDatepickerCancel>Cancel</button>
                      </mat-datepicker-actions>
                    </mat-datepicker>
                  </mat-form-field>
                </div>

                <div class="flex flex-col md:w-1/4 gap-2 pt-5">
                  <span class="font-semibold">To</span>
                  <mat-form-field>
                    <input placeholder="mm/dd/yyyy" formControlName="otherTo" matInput [matDatepicker]="otherTo"
                    [min]="applicationForm.get('otherFrom').value" [max]="sharedService.today" (blur)="validateOtherTo()"/>
                    <mat-datepicker-toggle matSuffix [for]="otherTo"></mat-datepicker-toggle>
                    <mat-datepicker #otherTo>
                      <mat-datepicker-actions>
                        <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                        <button mat-button matDatepickerCancel>Cancel</button>
                      </mat-datepicker-actions>
                    </mat-datepicker>
                    <mat-error *ngIf="applicationForm.get('otherTo').invalid">
                      To date cannot be before From date
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="flex flex-col gap-2 md:w-1/2">
                  <mat-checkbox formControlName="graduatedOther" labelPosition="before">
                    <span class="font-semibold">Graduated</span>
                  </mat-checkbox>
                  <mat-form-field>
                    <mat-label>Degree</mat-label>
                    <input matInput formControlName="otherDegree">
                  </mat-form-field>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>

      <div class="flex flex-col" [ngClass]="!isChange? 'md:flex-row gap-2' : ''">
        <mat-card [ngClass]="!isChange? 'md:w-1/2' : ''">
          <mat-card-header>
            <mat-card-title>
              <span class="font-semibold text-xl">Management Experience</span>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="flex flex-col gap-2">

              <label id="has-management-experience">
                Do you have two or more years of Management* experience in a health related field?
              </label>
              <mat-radio-group aria-labelledby="has-management-experience" formControlName="hasManagementExperience">
                <mat-radio-button [value]="true">
                  Yes
                </mat-radio-button>
                <mat-radio-button [value]="false">
                  No
                </mat-radio-button>
                <div *ngIf="applicationForm.get('hasManagementExperience').invalid && applicationForm.get('hasManagementExperience').touched">
                  <mat-error>
                    Please select Yes or No
                  </mat-error>
                </div>
              </mat-radio-group>

              <span>*Management experience means the administration, supervision or management of individuals in a health related field,
                      including hiring, assigning, evaluting and taking disciplinary actions (OAR 333-536-0005(20)).
              </span>

              <management-experience *ngIf="applicationForm.get('hasManagementExperience').value"
                                     [applicationId]="application.id"
                                     [isChange]="isChange"
                                     [statuses]="statuses"></management-experience>
            </div>
          </mat-card-content>
        </mat-card>

        <mat-card [ngClass]="!isChange? 'md:w-1/2' : ''">
          <mat-card-header>
            <mat-card-title>
              <span class="font-semibold text-xl">Professional Experience</span>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="flex flex-col gap-2">
              <label id="has-professional-experience">
                Do you have two or more years of Professional** experience in a health related field?
              </label>
              <mat-radio-group aria-labelledby="has-professional-experience" formControlName="hasProfessionalExperience">
                <mat-radio-button [value]="true">
                  Yes
                </mat-radio-button>
                <mat-radio-button [value]="false">
                  No
                </mat-radio-button>
                <div *ngIf="applicationForm.get('hasProfessionalExperience').invalid && applicationForm.get('hasProfessionalExperience').touched">
                  <mat-error>
                    Please select Yes or No
                  </mat-error>
                </div>
              </mat-radio-group>

              <span>**Professional experience means having a nursing, medical, therapeutic license,
                    certificate or degree used to work in a health related field (OAR 333-536-0005(20)).
              </span>

              <professional-experience *ngIf="applicationForm.get('hasProfessionalExperience').value"
                                       [applicationId]="application.id"
                                       [isChange]="isChange"
                                       [statuses]="statuses"></professional-experience>
            </div>
          </mat-card-content>
        </mat-card>
      </div>

      <mat-card [ngClass]="!isChange? 'md:w-2/3' : ''">
        <mat-card-content>
          <document [ngClass]="!isChange? 'md:w-1/2' : ''"
                    [entityId]="application.id"
                    [entityType]="sharedService.administratorApplication"
                    [statuses]="statuses"
                    [types]="administratorApplicationTypes"></document>
        </mat-card-content>
      </mat-card>
    </div>
  </form>
</div>
